import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@reach/tabs';
import * as React from 'react';

type TabBarProps = {
  /** The tabs contained within this tab bar. */
  tabs: Array<{
    /** The content to display when this tab is active. */
    content: React.ReactNode;
    /** The title of the tab. */
    title: string;
  }>;
};

/** A tab bar is a type of **molecule** that combines multiple HTML elements to display a set of layered sections of content, known as tab panels, that display one panel of content at a time. */
const TabBar: React.FC<TabBarProps> = ({ tabs }) => {
  return (
    <Tabs>
      {({ selectedIndex }) => {
        return (
          <>
            <TabList
              css={{
                borderBottom: '0.5px solid #E6E6E6',
                display: 'flex',
                marginBottom: '24px',
                minHeight: '28px',
              }}
            >
              {tabs.map((tab, tabIndex) => {
                const isSelected = selectedIndex === tabIndex;

                return (
                  <Tab
                    css={{
                      backgroundColor: 'transparent',
                      borderStyle: 'solid',
                      borderWidth: '0 0 4px 0',
                      borderBottomColor: isSelected ? '#00579C' : 'transparent',
                      color: isSelected ? '#00579C' : '#4D555C',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, sans-serif',
                      fontSize: '16px',
                      fontWeight: 'normal',
                      lineHeight: '20px',
                      marginRight: '16px',
                      padding: '0 4px',
                    }}
                    key={tab.title}
                  >
                    {tab.title}
                  </Tab>
                );
              })}
            </TabList>
            <TabPanels>
              {tabs.map((tab) => (
                <TabPanel
                  css={{ '&:focus': { outline: 'none' } }}
                  key={tab.title}
                >
                  {tab.content}
                </TabPanel>
              ))}
            </TabPanels>
          </>
        );
      }}
    </Tabs>
  );
};
export default TabBar;
